export enum GrowlType {
  Info = "info",
  Success = "success",
  SuccessLong = "successLong",
  Warn = "warn",
  Error = "error"
}
